import React, { useEffect, useState, useCallback } from "react";
import { Spinner } from "ui-components";

import {
  ClientHiringPipelineResponse,
  useOrganizationGetHiringData,
} from "@/hooks/api/generated";

import { AcrossQuartersCard } from "./AcrossQuartersCard";
import { HiringPipelineFilter, IQuarterOption } from "./HiringPipelineFilter";
import { QuarterCard } from "./QuarterCard";

export function HiringPipeline(): JSX.Element {
  const { mutate: getHiringData, status: getHiringDataStatus } =
    useOrganizationGetHiringData();

  const [hiringData, setHiringData] = useState<ClientHiringPipelineResponse>();

  const [filters, setFilters] = useState({
    startQuarter: 1,
    startYear: 2025,
    endQuarter: 4,
    endYear: 2025,
  });

  const fetchHiringData = useCallback(() => {
    getHiringData(
      { data: filters },
      {
        onSuccess: (data) => setHiringData(data),
        onError: () => {},
      }
    );
  }, [getHiringData, filters]);

  useEffect(() => {
    fetchHiringData();
  }, [fetchHiringData]);

  const handleFilterChange = useCallback(
    (from: IQuarterOption, to: IQuarterOption) => {
      setFilters((prev) => {
        if (
          prev.startQuarter === from.quarter &&
          prev.startYear === from.year &&
          prev.endQuarter === to.quarter &&
          prev.endYear === to.year
        ) {
          return prev;
        }
        return {
          startQuarter: from.quarter,
          startYear: from.year,
          endQuarter: to.quarter,
          endYear: to.year,
        };
      });
    },
    []
  );

  if (getHiringDataStatus === "pending" && !hiringData) {
    return (
      <div className="mt-10 w-full flex justify-center">
        <Spinner intent="brand-primary" size="lg" />
      </div>
    );
  }

  return (
    <div className="w-full">
      <HiringPipelineFilter onFilterChange={handleFilterChange} />

      {hiringData && <AcrossQuartersCard hiringData={hiringData} />}

      {hiringData?.quarters?.length ? (
        <div className="w-full grid grid-cols-1 md:grid-cols-4 gap-3 mt-5">
          {hiringData.quarters.map((quarter) => (
            <QuarterCard
              key={quarter.quarter + quarter.year}
              quarter={quarter}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}
